import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Specialty';
import Approach from './components/Approach';
import Portfolio from './components/Portfolio';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import GetStarted from './components/GetStarted';
import PlatformsSection from './components/PlatformsSection';
import ThankYou from './pages/ThankYou';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import Disclaimer from './pages/Disclaimer';
import EstateTTPlatform from './pages/EstateTTPlatform';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  React.useEffect(() => {
    if (window.location.pathname === '/') {
      const sectionId = sessionStorage.getItem('scrollToSection');
      if (sectionId) {
        console.log(`App: Found stored section ID: ${sectionId}, will scroll to it`);
        sessionStorage.removeItem('scrollToSection');

        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            console.log(`App: Found element #${sectionId}, scrolling into view`);
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            window.dispatchEvent(new CustomEvent('forceAnimations', {
              detail: { timestamp: Date.now() }
            }));
          } else {
            console.error(`App: Element #${sectionId} not found after delay`);
          }
        }, 1000);
      }
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="font-sans bg-white text-gray-900">
        <Header />
        <Routes>
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/platforms/estatett" element={<EstateTTPlatform />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/" element={
            <main>
              <Hero />
              <About />
              <Services />
              <Portfolio />
              <PlatformsSection />
              <Approach />
              <Team />
              <Contact />
            </main>
          } />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
